import { call, query } from "./calls";

export const Widget = {
    create: (widget) => call("/Widget", "POST", widget),
    update: (id, widget) => call(`/Widget/${id}`, "PUT", widget),
    search: (name) => query(`SELECT * from Widget WHERE name like '${name}'`),
    get: (id) => call(`/Widget/${id}`).then(result => (result && [result]) || []),
    getByIds: (widgetsId) => query (`SELECT * FROM Widget where id in (${widgetsId})`)
}
